import { render, staticRenderFns } from "./sitebods-page.vue?vue&type=template&id=03e6f25d&scoped=true&"
import script from "./sitebods-page.vue?vue&type=script&lang=js&"
export * from "./sitebods-page.vue?vue&type=script&lang=js&"
import style0 from "./sitebods-page.vue?vue&type=style&index=0&id=03e6f25d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e6f25d",
  null
  
)

export default component.exports